import { QuestionAsset } from '@vetahealth/tuna-can-api'
import { Input } from 'antd'

export function TextInput({ asset }: { asset: QuestionAsset & { response?: string } }): React.ReactNode {
  const { hint = '' } = asset.answerOptions[0] ?? {}

  return <Input value={asset.response} placeholder={hint} style={{ marginBottom: 20 }} />
}
